import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ACTIVITIES } from './constants';
import Legend from './Legend';
import Skeleton from '@mui/material/Skeleton';
const hours = Array.from({ length: 24 }, (_, i) => `${i % 12 || 12} ${i < 12 ? 'AM' : 'PM'}`);

const data = [
  { start: 0, end: 2.5, type: 'focus' },
  { start: 3.1, end: 3.5, type: 'break' },
  { start: 4, end: 9.5, type: 'focus' },
  { start: 10, end: 12.3, type: 'meeting' },
  { start: 13, end: 15, type: 'meeting' },
  { start: 16.5, end: 20, type: 'idea' },
  { start: 22, end: 22.5, type: 'focus' },
];
const ProductivityBar = () => {
  const [loading, setLoading] = useState(true);

  setTimeout(() => {
    setLoading(false)
  }, 2000);
  return (
    <Box>
      {/* Bar with grey background and activity segments */}

      {
        loading ? (
          <div
          >
            <Box p={2} sx={{ position: 'relative' }}>
              <Box display="flex" gap={2} alignItems="start" sx={{ justifyContent: 'space-between', overflow: 'hidden' }} >
                <Box>
                  <Skeleton
                    variant="rectangular"
                    height={200}
                    animation="wave"
                    sx={{ marginBottom: '12px', width: { xl: '160px', lg: '100%', md: '100%' } }}
                  />
                  <Skeleton
                    variant="rectangular"
                    height={38}
                    animation="wave"
                    sx={{ width: { xl: '160px', lg: '100%', md: '100%' } }}
                  />
                  <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: '10px' }}>
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                  </Box>
                </Box>
                <Box>
                  <Skeleton
                    variant="rectangular"
                    width={20}
                    height={200}
                    animation="wave"
                    sx={{ marginBottom: '12px' }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={20}
                    height={38}
                    animation="wave"
                  />
                  <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: '10px' }}>
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                  </Box>
                </Box>
                <Box>
                  <Skeleton
                    variant="rectangular"

                    height={200}
                    animation="wave"
                    sx={{ marginBottom: '12px', width: { xl: '250px', lg: '100%', md: '100%' } }}
                  />
                  <Skeleton
                    variant="rectangular"
                    sx={{ width: { xl: '250px', lg: '100%', md: '100%' } }}
                    height={38}
                    animation="wave"
                  />
                  <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: '10px' }}>
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                  </Box>
                </Box>
                <Box>
                  <Skeleton
                    variant="rectangular"
                    height={200}
                    animation="wave"
                    sx={{ marginBottom: '12px', width: { xl: '160px', lg: '100%', md: '100%' } }}
                  />
                  <Skeleton
                    variant="rectangular"
                    sx={{ marginBottom: '12px', width: { xl: '160px', lg: '100%', md: '100%' } }}
                    height={38}
                    animation="wave"
                  />
                  <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: '10px' }}>
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />

                  </Box>
                </Box>
                <Box>
                  <Skeleton
                    variant="rectangular"
                    width={130}
                    height={200}
                    animation="wave"
                    sx={{ marginBottom: '12px' }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={130}
                    height={38}
                    animation="wave"
                  />
                  <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: '10px' }}>
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />

                  </Box>
                </Box>
                <Box>
                  <Skeleton
                    variant="rectangular"
                    width={230}
                    height={200}
                    animation="wave"
                    sx={{ marginBottom: '12px' }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={230}
                    height={38}
                    animation="wave"
                  />
                  <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: '10px' }}>
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                  </Box>
                </Box>
                <Box>
                  <Skeleton
                    variant="rectangular"
                    width={20}
                    height={200}
                    animation="wave"
                    sx={{ marginBottom: '12px' }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={20}
                    height={38}
                    animation="wave"
                  />
                  <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: '10px' }}>
                    <Skeleton
                      variant="text"
                      animation="wave"
                      sx={{ fontSize: '12px', width: '30px' }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>

          </div>) : (
          <Box
            sx={{
              position: 'relative',
              height: '200px',
              bgcolor: '#f3f4f6', // light gray background
              borderRadius: 1,
              borderBottom: '5px solid #fff',
              overflow: 'hidden',
              background: '#fff'
            }}
          >
            {/* Activity Segments */}
            {data.map((slot, i) => {
              const left = `${(slot.start / 24) * 100}%`;
              const width = `${((slot.end - slot.start) / 24) * 100}%`;
              return (
                <Box
                  key={i}
                  sx={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left,
                    width,
                    backgroundColor: ' #EAECF1',
                  }}
                />
              );
            })}
          </Box>
        )
      }

      <Box>
        {
          loading ? (<div
          >

          </div>) :
            (

              <Box
                sx={{
                  position: 'relative',
                  height: 40,
                  bgcolor: '#f3f4f6', // light gray background
                  borderRadius: 1,
                  border: '1px solid #e0e0e0',
                  overflow: 'hidden',
                  background: '#fff'
                }}
              >
                {/* Activity Segments */}
                {data.map((slot, i) => {
                  const left = `${(slot.start / 24) * 100}%`;
                  const width = `${((slot.end - slot.start) / 24) * 100}%`;
                  return (
                    <Box
                      key={i}
                      sx={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left,
                        width,
                        backgroundColor: ACTIVITIES[slot.type].color,
                      }}
                    />
                  );
                })}
              </Box>
            )
        }

      </Box>

      {/* Time Labels */}

      <Box>
        {
          loading ? (<div
          >

          </div>) : (

            <Box
              sx={{
                mt: 0.5,
                display: 'flex',
                justifyContent: 'space-between',
                px: 0.5,
              }}
            >
              {hours.map((hour, i) => (
                <Typography
                  key={i}
                  variant="caption"
                  sx={{
                    color: '#888',
                    fontSize: 10,
                    textAlign: 'center',
                    width: '4.1667%', // 100 / 24
                  }}
                >
                  {hour}
                </Typography>
              ))}
            </Box>
          )
        }
      </Box>
      <Legend />
    </Box>
  );
};

export default ProductivityBar;


//new bar start
// import React, { useState, useEffect } from 'react';
// import { Box, Typography, Skeleton } from '@mui/material';
// import { ACTIVITIES } from './constants';
// import Legend from './Legend';

// const hours = Array.from({ length: 24 }, (_, i) => `${i % 12 || 12} ${i < 12 ? 'AM' : 'PM'}`);
// const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// // Example weekly data
// // Each day has multiple activity segments (start & end in hours)
// const weeklyData = {
//   Sun: [
//     { start: 0, end: 2.5, type: 'focus' },
//     { start: 3.1, end: 3.5, type: 'break' },
//     { start: 4, end: 9.5, type: 'focus' },
//   ],
//   Mon: [
//     { start: 9, end: 11, type: 'meeting' },
//     { start: 12, end: 15, type: 'focus' },
//     { start: 16, end: 18, type: 'idea' },
//   ],
//   Tue: [
//     { start: 8, end: 10, type: 'meeting' },
//     { start: 10.5, end: 13, type: 'focus' },
//   ],
//   Wed: [
//     { start: 9, end: 12, type: 'focus' },
//     { start: 14, end: 16, type: 'meeting' },
//   ],
//   Thu: [
//     { start: 7, end: 9, type: 'idea' },
//     { start: 10, end: 12, type: 'focus' },
//   ],
//   Fri: [
//     { start: 9, end: 11, type: 'meeting' },
//     { start: 13, end: 17, type: 'focus' },
//   ],
//   Sat: [
//     { start: 10, end: 13, type: 'idea' },
//     { start: 15, end: 17, type: 'break' },
//   ],
// };

// const ProductivityBar = () => {
//   const [loading, setLoading] = useState(true);

//   // ✅ Proper loading delay
//   useEffect(() => {
//     const timer = setTimeout(() => setLoading(false), 2000);
//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <Box>
//       {/* Skeleton Loader */}
//       {loading ? (
//         <Box>
//           {[...Array(7)].map((_, i) => (
//             <Box key={i} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//               <Skeleton variant="text" width={40} height={20} sx={{ mr: 2 }} />
//               <Skeleton variant="rectangular" width="100%" height={40} animation="wave" />
//             </Box>
//           ))}
//         </Box>
//       ) : (
//         <>
//           {/* Week view bars */}
//           {days.map((day) => (
//             <Box key={day} sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
//               {/* Day Label */}
//               <Typography
//                 variant="body2"
//                 sx={{
//                   width: '50px',
//                   textAlign: 'right',
//                   fontWeight: 500,
//                   mr: 2,
//                   color: '#555',
//                 }}
//               >
//                 {day}
//               </Typography>

//               {/* Activity Bar */}
//               <Box
//                 sx={{
//                   position: 'relative',
//                   flexGrow: 1,
//                   height: 30,
//                   bgcolor: '#f3f4f6',
//                   borderRadius: 1,
//                   border: '1px solid #e0e0e0',
//                   overflow: 'hidden',
//                 }}
//               >
//                 {weeklyData[day].map((slot, i) => {
//                   const left = `${(slot.start / 24) * 100}%`;
//                   const width = `${((slot.end - slot.start) / 24) * 100}%`;
//                   return (
//                     <Box
//                       key={i}
//                       sx={{
//                         position: 'absolute',
//                         top: 0,
//                         bottom: 0,
//                         left,
//                         width,
//                         backgroundColor: ACTIVITIES[slot.type]?.color || '#ccc',
//                       }}
//                     />
//                   );
//                 })}
//               </Box>
//             </Box>
//           ))}

//           {/* Hour labels (bottom) */}
//           <Box sx={{ mt: 2 }}>
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 px: 7,
//               }}
//             >
//               {hours.map((hour, i) => (
//                 <Typography
//                   key={i}
//                   variant="caption"
//                   sx={{
//                     color: '#888',
//                     fontSize: 10,
//                     textAlign: 'center',
//                     width: '4.1667%', // 100 / 24
//                   }}
//                 >
//                   {hour}
//                 </Typography>
//               ))}
//             </Box>
//           </Box>

//           {/* Legend */}
//           <Legend />
//         </>
//       )}
//     </Box>
//   );
// };

// export default ProductivityBar;

//new bar end
